import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19.902 4.108a3.75 3.75 0 0 0-5.304 0l-4.5 4.5a3.75 3.75 0 0 0 1.035 6.036.75.75 0 0 1-.646 1.354 5.25 5.25 0 0 1-1.449-8.45l4.5-4.501a5.25 5.25 0 1 1 7.424 7.425l-1.757 1.757a.75.75 0 1 1-1.06-1.061l1.757-1.757a3.75 3.75 0 0 0 0-5.303"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.514 8.374a.75.75 0 0 1 1-.353 5.25 5.25 0 0 1 1.449 8.45l-4.5 4.5a5.25 5.25 0 0 1-7.425-7.424l1.757-1.757a.75.75 0 1 1 1.06 1.06l-1.757 1.758a3.75 3.75 0 1 0 5.304 5.303l4.5-4.5a3.75 3.75 0 0 0-1.035-6.037.75.75 0 0 1-.354-1"
    }, null, -1)
  ])))
}
export default { render: render }